export const Colors = {
    darkGrey: "#2D3036",
    white_80: "#FFFFFFCC",
    white_10: "#FFFFFF1A",
    orange: "#EB6D26",
    black_01: "rgba(0, 0, 0, 0.1)",
    red_04: "rgba(221, 58, 58, 0.4)"
}
